export default {
  "additionalQuestion": {
    "adultFemale": "女性",
    "adultMale": "男性",
    "answerQuestions": "请回答以下追加问题。",
    "checkinTime": "入住时间",
    "checkoutTime": "退房时间",
    "moreDetailed": "需要知道关于您的入住详情",
    "notificationFromFacility": "有关设施的注意事项",
    "selectTime": "时间选择",
    "view": "检视"
  },
  "base": {
    "account": "账号",
    "apply": "应用",
    "attachFile": "附加文件",
    "backTo": "返回{0}",
    "booking": "预约一览",
    "browserWarning": "目前使用的浏览器无法打开官方网站。请安装最新的浏览器版本，再尝试打开。",
    "cancel": "取消",
    "close": "关闭",
    "confirm": "确定预约",
    "continue": "下一步",
    "collapse": "缩小",
    "delete": "刪除",
    "edit": "变更",
    "error": "很抱歉，系统发生错误，请再试一次。",
    "error02": "不好意思,处理过程时系统发生错误, 请稍后再试。",
    "errorPaymentMethod": "因各房间选择了不同的支付方式，故无法继续预约程序。请选择同一种支付方式，或是分别预约。",
    "oldErrorCode": {
      "1403": "此账号已被设施注册，需要重设密码，请返回登录页面，点击“忘记密码”。"
    },
    "errorCode": {
      "1903": "可预约的期间为今天起 {reservable_period_months} 个月。\n请指定可预约期间的日期。",
      "2401": "您只有{currentPoint}积分。无法使用{spendPoint}积分。",
      "3001": "发生超时错误。支付尚未处理。",
      "3002": "支付处理失败。",
      "3003": "此信用卡无法使用。",
      "3004": "请确认信用卡卡号。",
      "3005": "请确认有效日期是否正确。",
      "3006": "3D验证失败。",
      "3007": "信用卡输入错误或无法使用。",
      "3008": "3D验证已被取消。",
      "3009": "因多方要求，我们已经暂停3D验证。",
      "3011": "发生超时错误。支付尚未处理。",
      "3202": "无法获得点数余额。",
      "3203": "不好意思,处理过程时系统发生错误, 请稍后再试。",
      "3204": "付款过程失败，请使用其他卡，或稍后重试。",
      "3205": "此信用卡无法使用。",
      "3502": "无法获得点数余额。",
      "3504": "点数无法返还。请确认点数记录。"
    },
    "fileLimit80MB": "上传图片的上限为一张80MB",
    "upTo30FilesError": "不能附加超过 30 个文件",
    "upTo30Files": "最多30个文件",
    "textLengthLimit": "回答字数需在255字以内。",
    "GDPR": "GDPR政策",
    "here": "此处",
    "imageError": "图片读取失败。",
    "join": "会员注册",
    "languages": {
      "en": "English",
      "ja": "日本語",
      "ko": "한국어",
      "zh_Hans": "簡体中文",
      "zh_Hant": "繁體中文"
    },
    "loading": "搜寻中",
    "login": "登录",
    "logout": "退出",
    "logoutMessage": "您已登出帐号",
    "memberSignIn": "会员登入",
    "memberSignUp": "首次注册网上会员",
    "next": "下一步",
    "notSelected": "尚未选择",
    "noData": "没有数据",
    "optional": "选填",
    "pay": "支付",
    "previous": "上一页",
    "previousPage": "上一页",
    "privacyPolicy": "隐私条例",
    "readMore": "显示更多",
    "readLess": "隐藏",
    "recommended": "推荐",
    "remove": "删除",
    "required": "必填",
    "requireMessage": "必填栏位不能为空白。",
    "reservationStatuses": {
      "cancelled": "已取消",
      "done": "已预约"
    },
    "save": "保存",
    "signInUp": "登入/註冊",
    "submit": "提交",
    "termError": "请同意使用条款",
    "taxMessage": "现在显示的价格是税前价格加上8%的消费税。关于2019年10月后的预约，因为消费税会改变的关系，详细金额请参考预约确认画面的最终金额。",
    "termsOfUse": "使用条款",
    "topPage": "主页",
    "update": "更新",
    "warning": {
      "kidsChanged": "因此设施不对应指定的搜索条件，关于儿童的搜索条件已变更。"
    }
  },
  "bookingDetail": {
    "overlappedReservation": "您预订的的入住日和退房日期与{0}重叠，请预订前再次确认。\n*重疊的預訂可能是此品牌下的其他設施。",
    "overlappedReservationLink": "之前的预订",
    "overlappedReservationGuest": "您预订的的入住日和退房日期与目前的预订重叠，请预订前再次确认。\n*重叠的预订可能是此品牌下的其他设施。\n*如果已使用其他设备取消预订，则此检测可能有误，请检查您收到的邮件进行确认。",
    "overlappedReservationGuest2": "*如果已使用其他设备取消预订或清除cookies，则此检测可能有误，请检查您收到的邮件进行确认。"
  },
  "bookingResult": {
    "allUser": "所有用户",
    "availableBetween": "有效期间",
    "bath": "浴室",
    "bedCount": "{n}张床",
    "book": "预约",
    "bookAirline": "附机票的预订",
    "cancellationFreeUntil": "{0}之前(设施当地时间) 都可以免费取消",
    "cancellationPolicy": "取消规定",
    "discountAmount": "折扣额度",
    "excludeDuring": "除外期间",
    "forNights": "住宿{n}晚",
    "freeWifi": "免费WiFI",
    "followingSearchConditions": "该日程没有空房。",
    "guests": "入住人数",
    "includes": "包括",
    "planInformation": "包括",
    "lowestPriceInfo": "根据空房状况和折扣条件，日历上可能无法显示最低价格。关于实际的价格，请确认日历。",
    "maxAdults": "可最多容納{n}位大人入住。",
    "meals": "餐点",
    "memberExclusive": "会员独享",
    "membersOnly": "会员限定",
    "nonSmoking": "禁烟",
    "noRoomFound": "非常抱歉，按您输入的条件，未能搜到有空房。",
    "tryChanging": "请尝试{0}或设施。",
    "tryItem": "其他日期",
    "noRoomSelected": "尚未选择客房",
    "noRoomsAvailable": "非常抱歉，按您输入的条件，未能搜到有空房。",
    "noRoomsAvailableDesc": "请尝试其他日期或设施。",
    "notAvailable": "无法预约",
    "priceFor": "价格适用于",
    "priceForAdult": "大人 × {n}",
    "priceForChild": "儿童 × {n}",
    "priceForRoom": "房间",
    "paymentCreditCard": "信用卡支付",
    "paymentMethods": "支付方式",
    "paymentMethod": {
      "on_site": "酒店当地支付",
      "credit_card": "信用卡支付",
      "on_site_credit_card_required": "现场支付（需事前输入信用卡）",
      "deferred_payment": "公司代付",
      "credit_card_full": "信用卡支付全额",
      "credit_card_deposit": "信用卡支付订金",
      "bank_transfer": "银行转帐"
    },
    "paymentNewCreditCards": "以新的信用卡来支付",
    "paymentRegisteredCreditCards": "以登记过的信用卡来支付",
    "planDetails": "方案內容",
    "plansLimitForUpdating": "您无法选择变更最初所选择的住宿方案。",
    "price": "金额",
    "promotionMayChanged": "酒店可能会在无预告的情况下，在最终日前变更或中止促销活动。",
    "registerCard": "登记此信用卡",
    "regularRate": "标准价格",
    "reservationStartDate": "预约开始日期",
    "showRoomDetails": "显示客房详情",
    "roomDetails": "客房详情",
    "roomFeatures": "客房详情",
    "roomLeft": "仅剩{n}间房！",
    "roomAvailable": "剩{n}间房",
    "roomEnough": "尚有空房",
    "roomRate": "价格",
    "rooms": "房间",
    "roomSize": "客房大小",
    "roomSizeUnit": {
      "tatami_mats": "榻榻米"
    },
    "select": "选择",
    "selectNewDate": "重新选择日期",
    "serviceFeeDesc": "代理预约网站的最终价格已含服务费。",
    "sleeps": "入住人数",
    "smoking": "吸烟",
    "stopReservationUpdate": "停止预约更新程序",
    "targetUser": "目标用户",
    "taxExcluded": "不含税",
    "taxIncluded": "含税",
    "toilet": "洗手间",
    "totalPrice": "日元",
    "totalPriceForNights": "住宿{n}晚合计价格 | 住宿{n}晚合计价格 | 住宿{n}晚合计价格",
    "viewAll": "显示所有",
    "viewClose": "隐藏",
    "viewGallery": "查看所有图片",
    "viewLess": "隐藏",
    "viewMore": "显示所有的住宿方案  ({n}件)",
    "viewAllRooms": "查看所有{n}间客房",
    "wifi": "WiFi",
    "wifiOption1": "无WiFi",
    "wifiOption2": "免费",
    "wifiOption3": "付费",
    "searchResults": "搜寻结果:",
    "nPlans": "{n} 件",
    "nRoomTypes": "{n} 件"
  },
  "customAuth": {
    "failTitle": "登录失败",
    "failDesc": "因会员信息未注册，所以无法登录。"
  },
  "cancellationPolicy": {
    "policyHeader": "取消费详细如下,",
    "policyLine": "住宿日{0}日前:  {1}％的费用",
    "policyLineWithTime": "住宿日{0}日前{1}之后： {2}%的费用",
    "freePolicyLine": "住宿日{0}日前:  0％的费用",
    "noShowLine": "未入住且未联络:  {0}％的费用",
    "cancelOnTheDay": "住宿日当日:  {0}％的费用",
    "cancelOnTheDayFree": "入住当日{0}之前：免费取消",
    "cancelOnTheDayCharge": "入住当日{0}之后：{1}％的费用",
    "uponLocalTime": "所有的取消政策都基于预约设施的当地时间计算。",
    "ifBookedElsewhere": "透过其他订房网站或旅行社订房的旅客请由该网站或者直接向旅行社谘询。",
    "specialRate": "特别取消率: {0}",
    "guest": "客人"
  },
  "calendar": {
    "fullyBooked": "全被订满",
    "roomsLeft": "剩余空房数",
    "selected": "住宿日期",
    "unavailable": "没有空房",
    "unavailableNow": "暂不可预订"
  },
  "corporateAdmin": {
    "admin": "管理者",
    "checkInDate": "入住日",
    "download": "下载",
    "guestName": "顾客姓名",
    "hotelName": "客房名",
    "maxNumberStay": "最多住宿天数",
    "maxNumberStays": "最多住宿天数",
    "nMonths": "{n}个月",
    "nights": "入住天数",
    "numberOfRooms": "房间",
    "remaining": "还可预约的天数",
    "reservationData": "预约资讯",
    "reservationDataDesc1": "※使用详情仅显示透过本官网预约的数目的合计。所以，透过其他渠道（电话等）的预约将不会显示，敬请注意。",
    "reservationDataDesc2": "※预约・住宿完成后，将会需要数分钟~数十分钟的时间在本官网显示，敬请见谅。",
    "reservationDataDesc3": "※此画面将不会显示透过非本官网的其他渠道进行的住宿内容变更及取消。",
    "reservationDate": "预约日期",
    "reservationNumber": "预约号码",
    "reserved": "已经住宿天数",
    "status": "状态",
    "title": "企业管理者",
    "totalPrice": "价格",
    "period": "期间",
    "year": "年"
  },
  "creditCardForm": {
    "addNewCard": "输入新的信用卡",
    "cardExpiration": "有效期限",
    "cardExpirationConfirm": "请确认信用卡有效期限",
    "cardHolder": "信用卡持有者姓名",
    "cardHolderConfirm": "请确认信用卡持有者姓名",
    "cardHolderFormatError": "请用拼音字母输入姓名。",
    "cardHolderHelp": "输入您的全名（与信用卡上一致）",
    "cardNumber": "信用卡卡号",
    "cardNumberConfirm": "请确认信用卡卡号",
    "cardNumberHelp": "输入您的信用卡卡号",
    "cardRequired": "信用卡的信息仅是为了确保预约，我们不会从此信用卡扣款。但是若是依照{0}产生取消费用的情况，则会从此卡扣取。",
    "cardSecurityCode": "安全码（CVV)",
    "cardSecurityCodeConfirm": "请确认输入的安全码",
    "cardSecurityCodeHelp": "CVV",
    "ccvExample": "印在信用卡背面（Visa、Mastercard、JCB）或正面（American Express）的3位或4位数字。用于验证使用者是否合法持卡人，以及防止在线购物时的诈骗事件。",
    "creditCard": "信用卡",
    "expiredError": "请输入在退房当日有效的信用卡。",
    "month": "月",
    "payInAdvance": "若是经由{0}的预约，请使用信用卡事前支付费用。",
    "payInAdvanceVoucher": "若是经由{0}的预约，请使用信用卡事前支付费用。",
    "tappayNote": "我们使用TapPay 2048-bit SLL支付系统。 我们不会保存任何持卡人的信息。TapPay透过遵守Service Provide Level 1所认证的PCI DSS,来保护您的信用卡资讯。",
    "year": "年",
    "cardBrand": "信用卡组织",
    "cardBrandMismatch": "请输入正确的卡号或选择正确的信用卡组织",
    "paymentOverMillionError": "在线支付的金额超过100万日元则无法使用 VISA卡 和Master卡。请使用其他信用卡类別或选择其他付款方式。",
    "badCards": "由于系统变更，新的预订无法使用以下的卡。非常抱歉，请重新输入卡的信息。"
  },
  "gmoPaypalOptions": {
    "null": "请选择信用卡组织",
    "visa": "VISA",
    "master": "Mastercard",
    "mastercard": "Mastercard",
    "amex": "American Express",
    "jcb": "JCB",
    "diners": "Diners Club"
  },
  "downloadPasswordModal": {
    "label": "为了让信息加密，请输入密码。输入此密码，下载的zip文件才可解压。"
  },
  "extraItems": {
    "error": {
      "extraNumber": "请变更{name}的数目。可能预约的数目为{min}〜{max}。"
    }
  },
  "facilitySuggestion": {
    "distanceFrom": "距离：距此设施{n}千米",
    "from": "最优惠价格",
    "header": "附近可入住的设施",
    "soldOut": "搜索不到空房。请更改条件，重新搜寻。",
    "soldOutDesc": "非常抱歉，按您搜索的条件，未找到空房。",
    "visitHotelWebsite": "打开设施的页面"
  },
  "guestDetail": {
    "afterUpdate": "更改后",
    "bookingForSomeone": "为他人预订酒店，非本人亲自入住",
    "brrDiscount": "最优惠房价折扣",
    "confirmUpdates": "确定变更预约",
    "confirmPayByCard": "确定以信用卡支付",
    "coupon": "优惠码",
    "couponApplied": "已使用优惠码{code}。",
    "creansmaerdCouponApplied": "已使用优惠码{name}。",
    "couponCode": "优惠代码",
    "couponDiscount": "优惠码折扣",
    "couponExpired": "非常抱歉，此优惠码已不再有效。",
    "couponInvalid": "优惠码输入错误。",
    "couponLimitReached": "因使用上限的原因，我们不再提供此优惠码 {code}。",
    "couponMaxStays": "此优惠码的折扣仅适用于最开始的{n}晚。之后的天数按普通价格预约。",
    "couponTargetPlans": "优惠码适用方案",
    "couponNotUse": "不使用优惠码",
    "couponValidUntil": "有效期至 {date}",
    "creditCardWarning": "原本价格, 即最初预约的费用，会退还至您的信用卡，并以变更完成后的总价, 即最新价格重新付费。",
    "day": " 第 {n} 天",
    "email": "邮箱地址(请指定可接收{email})",
    "emailAgain": "邮箱地址（确认用）",
    "emailAgainConfirm": "两次输入的电子邮箱不一致。",
    "emailAgainHelp": "请再次输入电子邮箱。",
    "emailConfirm": "请输入正确的电子邮箱。",
    "emailHelp": "请输入电子邮箱。",
    "extras": "追加选项",
    "extraLeft": "剩 {count} {unit}",
    "extraOutOfStock": "沒有庫存",
    "fullName": "姓名",
    "fullNameError": "请输入姓名的拼音。",
    "guestDetails": "顾客详情",
    "guestName": "顾客姓名",
    "guestNameError": "请输入姓名的拼音。",
    "guestNameHelp": "请输入姓名",
    "guestNameKanji": "住宿者姓名(汉字)",
    "guestStayName": "客人姓名",
    "mainGuest": "主要联系人",
    "notes": "备注",
    "originalPaymentAmount": "原本价格",
    "promotionDiscount": "折扣",
    "phone": "电话号码",
    "phoneConfirm": "请提供正确的电话号码",
    "phoneHelp": "请输入电话号码",
    "priceBecomeCheaper": "由于促销活动内容会根据住宿设施的不同而有所变更，目前选择的住宿方案的价格比之前更加优惠。请确认现在的价格，然后进行预约。",
    "priceBecomeExpensive": "非常抱歉，由于促销活动内容会根据住宿设施的不同而有所变更，目前选择的住宿方案的价格比之前有所提高。请确认现在的价格，然后进行预约。",
    "priceDiff": "差价",
    "signupTerms": "本预约系统为tripla(株)提供, 顾客的个人资讯会与tripla(株)共享。我同意tripla{0}, {1}以及{2}。",
    "terms": "本预约系统为tripla(株)提供，顾客的个人情报会与tripla(株)共享。本预约完成后，表示已经同意tripla{0}，{1}及{2}。",
    "totalAmountWithTax": "合计金额（含税）",
    "totalWithoutTax": "合计金额（不含税）",
    "updateUserInformation": "更新以上除电子邮件以外关于会员信息的修改。",
    "cheaperAccommodationTax": "由于兌换了点数，预订的住宿稅也减少了。请在预订前查看最新住宿费。"
  },
  "lineLogin": {
    "buttonText": "使用LINE帐号登入"
  },
  "meta": {
    "facilities": "品牌设施",
    "sign_in": "登录",
    "organization_sign_in": "企业或组织登入页面",
    "sign_up": "会员注册",
    "search_results": "住宿方案一览表",
    "guest_detail": "输入顾客资讯",
    "payment_method": "输入付款方法",
    "completed": "完成预约",
    "my_account": "我的页面"
  },
  "membership": {
    "promotionRate": "促销折扣",
    "regularRate": "标准价格",
    "signUpFor": "会员价格"
  },
  "membershipForm": {
    "address": "地址",
    "alreadyHaveAccount": "已有帐号",
    "back": "上一页",
    "buildingName": "建物名称与房号",
    "changePassword": "更改密码",
    "changePasswordResult": "重新设定密码",
    "changePasswordResult02": "✓ 顾客的密码已重新设定。",
    "changePasswordResult03": "请点此再次登录。",
    "changePasswordSecondary": "请输入您的新密码",
    "confirmDeletedResult": "您已经成功退会。",
    "confirmNewPassword": "确认新密码",
    "confirmPassword": "确认密码",
    "confirmRegisterFail": "登入失败",
    "confirmRegisterFail02": "请再次创建账号。",
    "confirmRegisterResult": "电子邮箱认证",
    "confirmRegisterResult02": "✓ 已成功创建",
    "confirmRegisterResult03": "尽情享受住宿的时光",
    "createAccount2": "会员创建",
    "createAccount3": "会员创建",
    "dob": "出生日期",
    "email": "电子邮箱",
    "emailError": "请确认您的邮箱地址。",
    "emailPromotionCheck": "接收来自酒店的促销邮件。",
    "english_error": "请输入英文拼音",
    "locale_error": {
      "ja": "请输入英文拼音",
      "zh_Hant": "请输入英文拼音",
      "ko": "请输入英文拼音"
    },
    "enterDetail": "请输入您的资料",
    "first_name": "名字(英文拼音)",
    "firstNameLocales": {
      "ja": "名字(英文拼音)",
      "zh_Hant": "名字",
      "ko": "名字(英文拼音)"
    },
    "first_name_kanji": "",
    "first_name_kanji_placeholder": "",
    "first_name_placeholder": "Dawen",
    "firstNamePlaceHolderLocales": {
      "ja": "Dawen",
      "zh_Hant": "Da Ming",
      "ko": "Dawen"
    },
    "firstName": "名字",
    "firstNameError": "请输入您的名字。",
    "firstNameKana": "",
    "forgotPassword": "忘记密码",
    "forgotPassword02": "重新设定密码",
    "forgotPasswordError": "您输入的电子邮箱尚未注册会员。",
    "forgotPasswordResult": "重新设定密码",
    "forgotPasswordResult02": "✓ 已发送重新设定密码的链接至您的电子邮箱。",
    "forgotPasswordResultSecondary": "发送的邮件可能需要数分钟的时间接收，若10分钟后任未收到，请点击下列再次发送的按钮。",
    "forgotPasswordSecondary": "请输入您的电子邮箱，我们会发送重新设定密码的链接。",
    "gender": "性別",
    "generalError": "不好意思,处理过程时系统发生错误, 请稍后再试。",
    "guest_first_name": "名字(英文拼音)",
    "guest_first_name_kanji": "",
    "guest_last_name": "姓氏(英文拼音)",
    "guest_last_name_kanji": "",
    "header": "会员创建",
    "hiragana_error": "",
    "kanji_error": "",
    "last_name": "姓氏(英文拼音)",
    "lastNameLocales": {
      "ja": "姓氏(英文拼音)",
      "zh_Hant": "姓氏",
      "ko": "姓氏(英文拼音)"
    },
    "last_name_kanji": "",
    "last_name_kanji_placeholder": "",
    "last_name_placeholder": "Chen",
    "lastNamePlaceHolderLocales": {
      "ja": "Chen",
      "zh_Hant": "Wang",
      "ko": "Chen"
    },
    "lastName": "姓氏",
    "lastNameError": "请输入您的姓氏。",
    "lastNameKana": "",
    "membershipId": "会员号码",
    "membershipProgram": "会员制度",
    "name": "名字",
    "nationality": "国籍",
    "newPassword": "新密码 (请输入8个或以上的字符, 必须包含大写和小写英文字母、数字及符号。)",
    "noAccount": "希望成为我们的会员吗?",
    "occupation": "职业",
    "or": "或",
    "orContinueBelow": "或输入下方资料",
    "password": "密码",
    "passwordConfirmationError": "密码与确认密码不吻合",
    "passwordError": "请确认您的密码。",
    "passwordSignUp": "密码 (请输入8个或以上的字符, 必须包含大写和小写英文字母、数字及符号。)",
    "pleaseSelect": "選擇會員制度",
    "postCode": "邮递号码",
    "postCodeError": "仅可输入英文字母和数字。",
    "prefecture": "省份",
    "notApplicable": "不适用",
    "privacyPolicy": "隐私权政策",
    "promotionsCheckbox": "我想收到email的特别优惠和促销讯息",
    "resend": "再次发送",
    "resendConfirmationEmail": "未收到会员注册确认邮件的情况",
    "resendConfirmationEmailError": "此电子邮箱已经被注册。",
    "resendConfirmationEmailTitle": "再次发送会员注册确认邮件",
    "send": "发送",
    "setPassword": "更改",
    "setup": "会员创建",
    "setupResultSecondary01": "如果您想要再次尝试注册会员，请点击{0}。",
    "setupResultSecondary02": "已寄送确认邮件至登录的电子邮箱。\r\n目前为暂时登录的状态。请点击邮件中的URL以完成会员登录的手续。\r\n登录完成后即可登入。",
    "signIn": "登录",
    "signInHere": "登入",
    "signInTo": "登录{0}",
    "signUp": "创建会员账号",
    "signUpResult": "已发送确认邮件。",
    "signUpResult02": "已成功创建",
    "signUpResult02Secondary": "感谢您申请成为我们%{hotel_name}的会员。",
    "signUpResult02Secondary02": "A confirmation email has been sent to the email address you supplied.",
    "signUpResultSecondary": "感谢您申请成为我们%{hotel_name}的会员。",
    "signUpResultSecondary02": "为了完成创建手续，请查看确认邮件。",
    "signUpResultSecondary03": "请点击邮件中的链接，",
    "signUpResultSecondary04": "完成创建会员账号的手续。",
    "signUpSecondary": "仅需填写以下资料，即可立即创建账号",
    "term": "我同意{0}及{1}。",
    "termError": "Please accept to the terms and conditions",
    "termOfUse": "使用规则",
    "wifi": "Free in-room wifi",
    "yetReceived": "没有收到确认邮件？{0}",
    "resendEmail": "按此处再发送",
    "pleaseResetPassword": "您所输入的电子邮件帐号的註册已经确认，所以无需重新发送确认电子邮件。\n如果您知道密码，请{0}。\n如果您忘记了密码，请使用{1}选项。",
    "pleaseResetPasswordLink1": "直接登入",
    "pleaseResetPasswordLink2": "密码重置"
  },
  "membersihp": {
    "target": "适用会员"
  },
  "myAccount": {
    "changeLoginEmail": "变更电子邮箱",
    "changeLoginEmailDescription": "输入新的电子邮箱后,确认邮件就会发送至该邮箱。点击邮件中的URL，即可完成变更。若邮箱地址输入错误，需再次更改，确认邮件会发送至最新更改的邮箱地址。",
    "changeLoginEmailPendingText": "目前还在确认新的电子邮箱。请点击更新时发的邮件中的URL查看状态。",
    "changePassword": "重新设定密码",
    "confirmLoginEmail": "新的电子邮箱（确认中）",
    "edit": "编辑",
    "emailLabel": "邮箱地址",
    "loginEmail": "邮箱地址",
    "loginInfo": "登录信息",
    "notRegistered": "未有信用卡登录",
    "pageTitle": "账号内容",
    "password": "密码",
    "passwordLabel": "密码",
    "paymentInfo": "支付信息",
    "paymentOptions": "支付方法",
    "paymentOptionsDesc": "为了使您今后的支付手续更加快捷方便，您可以保存您的信用卡信息。所有的信用卡相关信息会进行严格的保密。",
    "pendingEmailText": "{n} 电子邮箱确认中",
    "personalInfo": "个人信息",
    "point": "点数",
    "removeAccount": "退会",
    "removeAccountConfirmationText": "是否确认退会？",
    "removeAccountReason01": "不会再次使用。",
    "removeAccountReason02": "住宿费太贵。",
    "removeAccountReason03": "对会员优待不感兴趣。",
    "removeAccountReasonInput": "请在此输入理由",
    "removeAccountReasonOthers": "其他",
    "removeAccountSecondaryText": "退会后所有的会员优待将无效。",
    "removeAccountSecondaryText02": "预约消息也将不会显示。",
    "removeCreditCard": "删除信用卡",
    "removeCreditCardConfirm": "您确定要删除登录的信用卡吗？",
    "resendEmail": "再次发送确认邮件",
    "resendEmailSuccess": "已经再次发送确认邮件。",
    "yourCreditCards": "已登录信用卡",
    "membershipId": "会员编号",
    "myQRCode": "我的二维码",
    "promotion": "促销",
    "historyStatus": {
      "expired": "已过期的点数",
      "future": "将获得的点数",
      "spent": "已使用的点数",
      "gained": "获得的点数",
      "refunded": "退还的点数"
    },
    "value": "价值",
    "badCards": "由于系统变更，新的预订无法使用此卡。",
    "unlockRank": "在{date}之前积累{points}{pointName}可以升级成{rank}级别。",
    "achievedHighest": "恭喜！您已获得最高等级。",
    "achievedHighestOnDate": "恭喜！您已达成条件，并将在{date}获得最高等级。"
  },
  "myProfile": {
    "cancel": "取消您的预约",
    "cancelled": "已取消",
    "change": "更改",
    "checkIn": "入住日期:",
    "checkOut": "退房日期:",
    "confirmationNo": "预约号码",
    "multiRoom": "多种房型",
    "myReservations": "预约内容",
    "myPage": "个人頁面 ",
    "noResultButtonText": "查找空房",
    "noResultText": "您尚未预约客房",
    "pageTitle": "帐户情报",
    "viewDetails": "显示详细内容",
    "viewFlightDetails": "确认附机票预订的详情"
  },
  "organization": {
    "enterDetail": "请输入帐户ID及密码",
    "signIn": "企业或组织登入页面"
  },
  "ota": {
    "changeLoginEmailPendingText": "目前还在确认新的电子邮箱。请点击更新时发的邮件中的URL查看状态。",
    "name": {
      "agoda": "Agoda",
      "booking_com": "Booking com",
      "expedia": "Expedia",
      "jalan": "Jalan",
      "rakuten_travel": "Rakuten Travel",
      "rakutenTravel": "Rakuten Travel"
    },
    "priceNotAvailable": "暂未提供"
  },
  "paymentMethod": {
    "paypalCheckbox1": "如果信用卡公司不支援3D Secure，则无法使用。",
    "paypalCheckbox2": "基於发卡公司需要检测或者防止非法使用信用卡的事件，本公司从客户收集的个人信息等将提供给客户使用的发卡公司。",
    "paypalCheckbox3": "姓名、电话号码、电子邮箱、互联网使用环境的信息等。",
    "paypalCheckbox4": "如果客房所使用的发卡公司在日本国外，这些信息可能会转移到发卡公司所属的国家。",
    "paypalCheckbox5": "如果客户为未成年人士，请在父母或者法定监护人的同意下使用本服务。",
    "credit_card": "預結算",
    "payments": {
      "credit_card": "信用卡支付"
    },
    "deferred_payment": "公司代付",
    "on_site": "当场支付",
    "on_site_credit_card_required": "当场支付",
    "type": "支付方式",
    "twd_credit_card": "信用卡支付全额",
    "twd_credit_card_deposit": "信用卡支付订金",
    "bank_transfer": "银行转帐",
    "paymentPromotion": "付费促销",
    "paymentPromotionTooltip": "酒店可能会变更或提早终止促销活动，恕不另行通知。"
  },
  "pointHistory": {
    "cancellation": "取消",
    "dateColumn": "日期",
    "descriptionColumn": "详细内容",
    "failToLoadErrorMessage": "很抱歉，点数纪录载入失败",
    "noData": "您目前没有任何点数的纪录",
    "pointExpirationColumn": "点数失效期限",
    "pointHistory": "点数纪录",
    "pointsColumn": "点数",
    "pointUse": "使用点数",
    "stay": "住宿",
    "viewMore": "显示更多",
    "exchangeDigico": "{point}转换",
    "exchangeDigicoDesc": "请输入您希望转换为Digico点数的{point}数目。Digico点数可转为用于Amazon，Apple，Google的点数。一经转换将无法为您复原。转换后的Digico点数仅有180天的有效期。此服务仅可在日本进行。转换后，设施将无法回答关于Digico点数的问题。关于Digico点数的更多详情，请查看{link} 。",
    "exchangeDigicoLink": "点此",
    "exchangeDigicoLog": "Digico点数转换",
    "exchangeAvaliablePoints": "可转换的{point}合计",
    "exchangeBtn": "转换",
    "exchangeHistory": "{point}转换",
    "exchangedAmount": "转换金额",
    "exchangedDigicoCode": "代码",
    "exchangeConfirm": "一经转换将无法为您复原。您确定希望转换{point}吗？",
    "exchangeConfirmBtn": "继续",
    "digicoPointUrl": "Digico点数转换URL：",
    "invalidAmount": "请输入有效的点数数。",
    "totalBalance": "总共点数",
    "currentPoints": "可用的点数",
    "futurePoints": "将获得的点数"
  },
  "pointSpending": {
    "balance": "可使用的点数",
    "errors": {
      "incorrectAmount": "如要使用点数,需以每{n}点来使用。",
      "moreThanPrice": "使用的点数无法超过所需的付款金额。",
      "upToBalance": "您输入的点数已超出持有的额度, 请修改。",
      "pointUsageError": "总付款金额若为0，是无法进行信用卡支付的。为了启用在线支付，您可以在上一步减少点数的使用。"
    },
    "minimumAmount": "使用点数时, 最低需使用{0}点数。",
    "points": "分",
    "saveForLater": "这次无法使用点数",
    "updateRule": "您无法使用已用于原来预约的点数。我们会在更新预约后返还点数。",
    "useAll": "使用全部的点数",
    "useAmount": "使用部分点数",
    "title": "点数"
  },
  "points": {
    "naming": {
      "default": "点数",
      "history": "{point}履歴",
      "available": "可使用{point}",
      "future": "将获得{point}",
      "expired": "已过期{point}",
      "gained": "获得{point}",
      "spent": "已使用的{point}",
      "save": "保存{point}以备后用",
      "redeem": "兌换全部{point}",
      "refunded": "退还的{point}",
      "miniSpending": "最少使用{point}必须为 {number} 或更多。",
      "useIncrements": "您可以以{number}递增使用{point}",
      "discount": "{point} 优惠",
      "earn": "预订此房间可获得{number}{point}",
      "checkOut": "{point}将在退房日的3天后添加。",
      "usePoint": "使用{point}",
      "empty": "目前没有任何{point}记录。",
      "total": "总共",
      "availableBalance": "可使用的{point}",
      "redeemRemark": "使用部分{point}",
      "cannotUse": "您无法使用已用于原来预约的{point}。我们会在更新预约后返还{point}。"
    }
  },
  "progressBar": {
    "confirmationSubtitle": "您的房间已经预约",
    "confirmationTitle": "预约完成",
    "guestSubtitle": "请填写您的详情",
    "guestTitle": "顾客详情",
    "paymentSubtitle": "选择支付方式",
    "paymentTitle": "支付"
  },
  "reservation": {
    "cancelled": "已取消",
    "completed": "已完成",
    "upcoming": "即将到来"
  },
  "reservationAction": {
    "applyGOTO": "申请 优惠码",
    "bookingCancel": "取消您的预约",
    "bookingUpdate": "更新顾客详情",
    "corporateSignInRequired": "公司法人若希望更新预约，需登录账户。",
    "differentFacilityWarning": "为了更新您的预约，请透过已预约的设施登录。",
    "everythingCorrectSubtitle": "您可以在此处更改您的資料或取消预约。",
    "everythingCorrectTitle": "管理您的预约",
    "invoiceDownload": "下载收据",
    "madeMistakeHelp": "我们期待下次再为您服务。",
    "madeMistakeTitle": "您的预约已经取消",
    "memberSignInRequired": "需登录会员后，才可更新预约。",
    "pleaseCancelAll": "若想取消所有的客房, 请直接取消预约。",
    "payByCreditCard": "更改為信用卡事前支付",
    "reductionOfNights": "缩短住宿期间",
    "reductionOfRooms": "减少客房数",
    "selectRoomsToCancel": "请选择想取消的客房",
    "signOutRequired": "需退出登录会员后，才可更新预约。",
    "updateExpired": "此预约已超过可变更的期限, 故无法更改。",
    "updateItinerary": "变更预约",
    "differentAccountWarning": "请使用正确的帐户登录以更新预订",
    "differentOrgWarning": "请使用正确的公司法人账户登录以更新预订",
    "coupon": {
      "signOutRequired": "请退出帐户后才申请使用优惠券。",
      "memberSignInRequired": "需登录会员后，才可使用优惠券。",
      "corporateSignInRequired": "需登录公司法人的账户后，才可使用优惠券。",
      "differentFacilityWarning": "如果想使用优惠券，请透过已预约的设施登录。",
      "differentAccountWarning": "请使用正确的帐户登录以使用优惠券。",
      "differentOrgWarning": "请使用正确的公司法人账户登录以使用优惠券。"
    },
    "notEnoughStays": "所选的住宿期间应等于或大于此预约所设定的最少住宿天数（{0}晚）。"
  },
  "reservationCancellation": {
    "cancel": "取消预约",
    "cancellationConfirm": "确定要取消此预约吗？",
    "cancellationFee": "取消费用",
    "cancellationOnDay": "当日取消无法在线上进行。",
    "cancellationPolicy": "取消规定",
    "cancellationTitle": "取消您的预约",
    "contactByChatPhone": "麻烦请使用电话与我们联系。",
    "contactByPhone": "麻烦请使用电话与我们联系。",
    "contactPhone": "电话：{0}",
    "keep": "保留预约",
    "nonRefundable": "无法退款",
    "reason": "请告知您取消的理由？",
    "reasonDifferentHotel": "我选择别家酒店。",
    "reasonNbTrvellers": "行程人数所有变更。",
    "reasonOther": "其他",
    "reasonOtherHelp": "如选择其他，请提供详细理由。",
    "reasonRoomCheaper": "我可在别处以更便宜的价格预约。",
    "reasonTripCancelled": "我的行程已经取消。",
    "roomNbCancelFee": "Room {0} cancellation fee",
    "totalCancelFee": "Total cancellation fee"
  },
  "reservationConfirmation": {
    "cancellationFreeUntil": "{0} 之前都可以免费取消",
    "cannotChangePlan": "您无法变更住宿方案。",
    "confirmationEmail": "我们已经向您的邮箱{0}发送邮件。",
    "extra": {
      "answer": "回答",
      "dateTime": "使用日期和时间",
      "extrasPrice": "追加选项",
      "items": "选择数量",
      "notes": "备注",
      "price": "价格",
      "priceIncludeTax": "价格（含税）",
      "question": "问题",
      "roomPrice": "客房总价"
    },
    "extrasSubtotal": "追加选项价格总额",
    "nonRefundableReminder": "此预约不可退款，一经预约，取消时将收取全额费用。",
    "originalReservationPlans": "此预约所选择的住宿方案。",
    "reservationDetail": "预约内容",
    "selectNewItinerary": "请重新选择住宿期间及入住人数并开始搜索。",
    "updateBooking": "变更预约",
    "cannotUpdateTooltip": "因为设施工作人员之前根据您的同意修改了价格及预约内容，目前您无法更新/取消预订。"
  },
  "reservationDetail": {
    "adult": "{n}位",
    "accommodationTax": "住宿稅",
    "checkIn": "入住日期",
    "checkOut": "退房日期",
    "child": "{n}位",
    "dayUse": "当日休息方案",
    "discount": "折扣",
    "discountedPrice": "兑换点数",
    "guest": "{n}位",
    "maxGuests": "最多可容纳人数",
    "night": "{n}晚",
    "nights": "入住天数",
    "numberOfGuest": "人數",
    "numberOfNights": "入住天数",
    "originalPrice": "总价",
    "pointDiscount": "点数兑换金额",
    "pointInstruction": "您将在退房后的第三天获取点数",
    "pointReward": "此预约可积累{0}分",
    "priceBreakDown": "收费明细",
    "reservationNumber": "预约号码",
    "roomDetails": "客房详情",
    "roomNb": "客房 {0}",
    "roomPlan": "住宿方案",
    "roomRate": "客房价格",
    "roomType": "房型",
    "searchNecessary": "* 当您需要更改或取消预约时均需要提供此预约编号, 建议您打印此页。",
    "serviceFee": "服务费",
    "subTotal": "小计",
    "subTotalWithoutTax": "小计（不含税）",
    "tax": "税",
    "taxIncluded": "含税",
    "total": "支付金额（含税）",
    "depositAmount": "订金金额（{0}%）",
    "remainAmount": "剩余需付金额",
    "withTax": "含税",
    "depositNecessary": "您需要通过我们的线上系统支付{0}%的订金，来完成预约。"
  },
  "reservationPayment": {
    "creditCardPayment": "信用卡提前支付",
    "onSitePayment": "入住时付费(无需事先支付)",
    "paymentMethod": "支付方式",
    "pendingPage": {
      "launchButton": "3D验证",
      "text01": "点击此按钮，转至3D验证密码输入页面。",
      "text02": "若未在15分钟以内完成密码输入，预约处理将会被取消。",
      "text03": "若未输入您的密码，预约将无法完成。空房可能会被其他顾客预约。",
      "text04": "信用卡支付由tripla代为处理，故3D验证的店铺名显示「tripla」。",
      "timeOutError01": "发生超时错误。",
      "timeOutError02": "支付尚未处理。",
      "authError01": "支付处理失败。",
      "error01": "预约处理过程中出现一个错误。",
      "error02": "支付尚未处理。",
      "error03": "点击「上一页」按钮，在搜索页面再次预约。"
    },
    "planError": "非常抱歉，已选择的方案有相冲突的支付方式，请再次尝试。",
    "selectCreditCards": "请选择要使用的信用卡"
  },
  "reservationReceipt": {
    "customerName": "姓名",
    "deferredWithoutDownload": "因为公司代付，所以不提供发票。",
    "download": "下载收据",
    "downloadOnCheckout": "您可在退房日当日或之后下载收据。",
    "onSite": "若选择在酒店当地支付，前台会为您发行收据。"
  },
  "searchBar": {
    "addRoom": "加订一间客房",
    "adult": "{n}位大人",
    "adults": "大人",
    "age": "年龄",
    "agree": "同意",
    "bed": "加床铺",
    "checkIn": "入住日期",
    "checkInAndOut": "办理入住 - 退房日期",
    "checkOut": "退房日期",
    "child": "{n}位儿童",
    "childN": "儿童 {n}",
    "children": "儿童",
    "childrenAgeAtCheckout": "退房时儿童的年龄",
    "childrenAgeInfant": "年龄 {from}-{to}",
    "childrenAgePrimary": {
      "primary": "年龄 {from}-{to}",
      "primaryBottom": "年龄 {from}-{to}",
      "primaryTop": "年龄 {from}-{to}"
    },
    "childrenAges": "同行儿童年龄",
    "childrenAgeSharedBed": "年龄 {from}-{to}",
    "childrenMealBedding": {
      "meal_no": "不含用餐和床铺",
      "meal_no_bedding": "含床铺",
      "meal_same_as_adult_bedding": "含用餐和床铺",
      "meal_yes": "含用餐",
      "meal_yes_bedding": "含用餐和床铺"
    },
    "cookieConsent": "此网站使用cookies来提高用户体验。若继续使用此网站，则表示您已经同意我们使用cookies。若希望了解更多详情，请查看{0}。",
    "privacyPolicy": "隐私条例",
    "perRoomGuests": "一间房入住的人数",
    "dates": "住宿期间",
    "dayUse": "搜索当日休息方案",
    "defaultArea": "全部地区",
    "edit": "更改",
    "filter": "选择条件",
    "guests": "入住人数",
    "hotel": "酒店",
    "maxChildrenWarning": "每位大人最多可携带{n}位儿童。",
    "pleaseSelectHotel": "请选择酒店名",
    "room": "{n}间房间",
    "rooms": "房间",
    "search": "开始搜寻",
    "showOnlyAvailable": "仅显示可预约的房间/方案",
    "sort": "自行排序",
    "sortOption": {
      "price_high_to_low": "按据价格排序 (从高至低)",
      "price_low_to_high": "按价格排序 (从低至低)",
      "recommended": "按推荐排序"
    },
    "to": "至",
    "undated": "日期未定",
    "nights": "入住天数",
    "yearOld": "{n} 岁",
    "enableWBFSearch": "有效搜寻住宿+机票方案",
    "stayFlightTab": "住宿+机票",
    "stayTab": "住宿",
    "processInJapTxt": "预约流程将以日文进行。",
    "processMaxTxt": "预约流程将以日文进行，最大预约房间数为5。",
    "undatedWarning": "若每间客房的人数不一样，则无法在不输入入住日期的情况下，搜索空房。"
  },
  "searchReservation": {
    "enterDetail": "请输入您的预约号及电子邮箱",
    "enterReservationNumber": "请输入预约号码",
    "manageBooking": "住宿预约确认・取消",
    "searchFailed": "我们需要以下的信息进行下一步。很抱歉，电子邮箱或预约号码不正确。请再试一次。"
  },
  "searchResultByPlan": {
    "hide": "隐藏",
    "planContent": "方案内容",
    "plans": "方案",
    "rooms": "客房",
    "showPlan": "显示方案详情",
    "moreDetail": "显示更多"
  },
  "snsLogin": {
    "loginWith": "以{0}登录",
    "enterPassword": "请输入您的密码以继续",
    "existingPrompt": "你好像有一个现有帐户。请问要将您的帐户与{sns}连接吗？您之后可以使用{sns}或电子邮件/密码来登录。",
    "signUpDescription": "非常感谢您连接您的 {sns} 帐号, 请提供下述的资讯以完成创建帐号"
  },
  "voucher": {
    "cancel": "取消变更",
    "confirm": "确认",
    "number": "预约号码",
    "purchseComplete": "已购买",
    "selectStay": "请选择入住日期",
    "stillVoucher": "目前此住宿折扣券仍未使用, 并没有任何预约客房的纪录及其入住/退房日。",
    "ThankPurchase": "感谢您购买住宿折扣券。",
    "update": "确定变更",
    "updateItinerary": "变更预约",
    "updateItineraryDesc": "请更改住宿日期。点击「确定变更」的按钮，确定变更。",
    "usingVoucher": "使用此住宿折扣券预约客房",
    "valid": "有效的住宿折扣券",
    "voucherDesc": "您可以使用此住宿折扣券预约客房, 请在此选择入住日及退房日。",
    "voucherDetails": "住宿折扣券详情",
    "voucherNumber": "住宿折扣券代码"
  },
  "triplaPay": {
    "isPaid": "本次支付成功完成",
    "isAlreadyPaid": "已付款",
    "isFailed": "本次支付未能成功",
    "isCompleted": "本次支付成功完成",
    "isRefunded": "您的支付已退还",
    "refundedAt": "退款日期",
    "paidAt": "支付日期",
    "isCancelled": "本次支付已取消",
    "total": "支付金额",
    "pleaseReload": "此任务未能在一小时内完成，请重新加载。",
    "reload": "重新加载",
    "subject": "支付主体",
    "amountIsChanged": "支付金额已变更，请点击「更新」按钮，重新加载。",
    "terms": "本交易系统由tripla (公司) 提供，请客人理解个人信息将与tripla (公司)共享的条款后，并同意tripla {0}、{1} 和{2}，",
    "paypalTerms": "信用卡交易会使用PayPal，使用详情会记载在您的信用卡账单上。",
    "temsOfUse": "使用规则",
    "privacyPolicy": "隐私条例",
    "gdprPolicy": "GDPR政策",
    "pleaseScan": "请扫描二维码"
  },
  "triplaPayIssues": {
    "INVALID_PARAMETER_SYNTAX": "请检查你输入的信息",
    "INVALID_EXPIRATION_YEAR": "请确认有效日期是否正确。",
    "Invalid_card_number": "请确认信用卡卡号。",
    "Others": "请检查你输入的信息"
  }
}